'use client';

import React, { ReactElement } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { hotjar } from 'react-hotjar';
import { useLenis } from 'lenis/react';

export default function SmoothScroller({ children, href }: { children: React.ReactNode, href: string | number }) {
  const lenis = useLenis();
  const router = useRouter();
  const currentPath = usePathname();

  const navigate = () => {
    const withPage = href.toString().startsWith('/');
    if (hotjar.initialized())
    {
      hotjar.stateChange(href.toString());
    }

    const target = typeof href === 'string' ?
      href.includes('#')
        ? '#' + href.split('#')[1]
        : 0
      : href;

    if (withPage && currentPath !== href.toString().split('#')[0])
    {
      router.push(href.toString(), { scroll: false });
      setTimeout(() => {
        lenis?.scrollTo(target, { offset: -120 });
      }, 1500);
      return;
    }

    if (typeof href === 'string' && href.includes('#')) {
      if (history) {
        history.pushState(null, '', href);
      }
    }

    lenis?.scrollTo(target, { offset: -120 });
  };

  // set onClick to navigate for the children element
  const child = React.Children.only(children);
  if (React.isValidElement(child))
  {
    const props = child.props as React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;
    return React.cloneElement(child as ReactElement<any>, {
      onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        props.onClick != undefined ? props.onClick(event) : null;
        navigate();
      }, className: `${ props.className } hover:cursor-pointer`,
    });
  }
}
